import { render, staticRenderFns } from "./Nikkei.vue?vue&type=template&id=11c83320&"
import script from "./Nikkei.vue?vue&type=script&lang=js&"
export * from "./Nikkei.vue?vue&type=script&lang=js&"
import style0 from "./Nikkei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports